import React, { FC } from "react";
import { Redirect, Route, Switch } from "react-router";
import {
  UsersPage,
  UserProfilePage,
  StyleGuidePage,
  PageNotFound,
  HelpAndDocs,
  OtherReports,
  Roster,
  DirectDepositUpdatePage,
  NetEarningsPage,
  GrossEarningsPage,
  UsageReportPage,
  EnrollmentReportPage,
  DashboardPage,
  OffCycleDisbursementsReport,
  DisbursementsFileUpload,
  RewardsSetup,
  RewardsReport,
  AnomalyReportPage,
} from "Components/Pages";
import { queryToProps } from "Api";
import { goToPageCreator } from "Hooks/useGoTo";
import InternalRoutes from "Shared/Constants/InternalRoutes";
import { EmployeeProfilesQueryProvider } from "Hooks/useEmployeeProfilesQueryContext";
import AdminsAndRolesTable from "Components/Pages/AdminsAndRoles/AdminsAndRolesTable/AdminsAndRolesTable";
import UserSettingsPage from "Components/Pages/Settings/UserSettingsPage";
import { EmployeProfileQueryProvider } from "Hooks/useEmployeeProfileQueryContext";
import { ComplianceReports } from "Components/Pages/ComplianceReports/ComplianceReportsPage";
import { PresettlementExclusionsReport } from "Components/Pages/PresettlementExclusionsPage/PresettlementExclusionsPage";
import { BalanceDistributorReport } from "Components/Pages/BalanceDistributorReport/BalanceDistributorReport";
import ConfigurationSettings from "Components/Pages/ConfigurationSettings/ConfigurationSettings";

const {
  users,
  userTab,
  userStatements,
  grossEarnings,
  roster,
  netEarnings,
  netEarningsAnomalyReport,
  directDeposit,
  otherReports,
  admins,
  help,
  style,
  notFound,
  enrollmentReport,
  usageReport,
  complianceReports,
  complianceReportsTab,
  paystubReport,
  userSettings,
  presettlementExclusions,
  balanceDistributorReport,
  disbursementsReport,
  disbursementsFileUpload,
  rewardsReport,
  rewardsSetup,
  settings,
} = InternalRoutes;
const Routes: FC = () => {
  return (
    <Switch>
      <Route component={GrossEarningsPage} exact path={grossEarnings} />
      <Route exact path="/" render={() => <DashboardPage />} />
      <Route
        exact
        path={users}
        render={() => (
          <EmployeeProfilesQueryProvider>
            <UsersPage />
          </EmployeeProfilesQueryProvider>
        )}
      />
      <Route
        path={userTab}
        render={({ history, match }) => (
          <EmployeProfileQueryProvider {...match.params}>
            <UserProfilePage history={history} {...match.params} />
          </EmployeProfileQueryProvider>
        )}
      />
      <Redirect from="/users/:id" to={userStatements} />
      <Route path={roster} render={() => <Roster text="User Roster" />} />
      <Route component={NetEarningsPage} exact path={netEarnings} />
      <Route
        component={AnomalyReportPage}
        exact
        path={netEarningsAnomalyReport}
      />
      <Route
        path={directDeposit}
        render={() => <DirectDepositUpdatePage text="Direct Deposit" />}
      />
      <Route path={otherReports} render={() => <OtherReports />} />
      <Route
        path={complianceReportsTab}
        render={({ history, match }) => (
          <ComplianceReports
            title="Compliance Reports"
            tab={match.params.tab}
            history={history}
          />
        )}
      />
      <Redirect from={complianceReports} to={paystubReport} />
      <Route
        exact
        path={admins}
        render={({ history, location }) => {
          const queryProps = queryToProps(location.search);
          return (
            <AdminsAndRolesTable
              goToPage={goToPageCreator(history, admins)}
              queryProps={queryProps}
              title="Admins & Roles"
            />
          );
        }}
      />
      <Route exact path={enrollmentReport} component={EnrollmentReportPage} />
      <Route exact path={usageReport} component={UsageReportPage} />
      <Route exact path={userSettings} component={UserSettingsPage} />
      <Route
        exact
        path={presettlementExclusions}
        component={PresettlementExclusionsReport}
      />
      <Route
        exact
        path={balanceDistributorReport}
        component={BalanceDistributorReport}
      />
      <Route
        exact
        path={disbursementsReport}
        component={OffCycleDisbursementsReport}
      />
      <Route
        exact
        path={disbursementsFileUpload}
        component={DisbursementsFileUpload}
      />
      <Route exact path={rewardsSetup} component={RewardsSetup} />
      <Route exact path={rewardsReport} component={RewardsReport} />
      {/* <Route exact path={settings} component={ConfigurationSettings} /> */}
      <Route path={help} render={() => <HelpAndDocs />} />
      <Route path={style} component={StyleGuidePage} />
      <Route path={notFound} render={() => <PageNotFound text="404" />} />
      <Route render={() => <PageNotFound />} />
    </Switch>
  );
};
export default Routes;
